var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "white",
    stroke: "#DCF1FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10510_19513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6663 14.3333H18.333C16.1277 14.3333 14.333 16.128 14.333 18.3333V31.6667C14.333 33.872 16.1277 35.6667 18.333 35.6667H31.6663C33.8717 35.6667 35.6663 33.872 35.6663 31.6667V18.3333C35.6663 16.128 33.8717 14.3333 31.6663 14.3333ZM24.9997 30.6C24.9997 30.6 19.6663 26.896 19.6663 23.88C19.6663 22.2893 20.8597 21 22.333 21C23.8063 21 24.9997 22.076 24.9997 23.6667C24.9997 22.076 26.193 21 27.6663 21C29.1397 21 30.333 22.2893 30.333 23.88C30.333 26.896 24.9997 30.6 24.9997 30.6ZM16.9997 11.8013V9H32.9997V11.8013C32.5609 11.7117 32.1142 11.6666 31.6663 11.6667H18.333C17.877 11.6667 17.4303 11.7133 16.9997 11.8013ZM18.333 38.3333H31.6663C32.1223 38.3333 32.569 38.2867 32.9997 38.1987V41H16.9997V38.1987C17.4303 38.2867 17.877 38.3333 18.333 38.3333Z",
    fill: "#343A40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10510_19513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitness);
export default __webpack_public_path__ + "static/media/fitness.518080f2a1f4fea13c2b32dbc69fc31f.svg";
export { ForwardRef as ReactComponent };